import React, { useEffect, useRef, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Form, Input } from "antd";
import Globais, { AlterarFormatoData, validateToken } from "../../components/Globais";
import { StringParam, useQueryParams } from "use-query-params";
import moment from "moment";
import { MaskedInput } from "antd-mask-input";
import styled from "styled-components";
import axios from "axios";

export default function ViewFormularioHospedes() {
  const ButtonStyle = styled.button`
    width: 100vw;
    height: 100vh;
    max-height: 50px;
    max-width: 120px;
    margin-top: 20%;
    background: rgb(0, 54, 68);
    color: #ffffff;
    font-weight: bold;
    border-radius: 10px;
    :hover {
      background: rgb(0, 22, 28);
      cursor: pointer;
    }
  `;

  interface Convidado {
    nome: string;
    cpf: string;
    dataNascimento: string;
  }
  interface FormularioHospedes {
    hospedes: Convidado[];
  }
  const [formConvidado, setFormConvidado] = useState<FormularioHospedes>({
    hospedes: [{ nome: "", cpf: "", dataNascimento: "" }],
  });
  const [errorFields, setErrorFields] = useState<any>({});
  const [form] = Form.useForm();
  const [idReservaOta, setIdReservaOta] = useQueryParams({
    idReservaOta: StringParam,
  });
  const idReservaRef = useRef<number>();
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState<React.ReactNode>("");

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage(""); // Remove a mensagem após 5 segundos
      }, 5000); // 5000ms = 5 segundos

      return () => clearTimeout(timer); // Limpa o temporizador se o componente desmontar ou se o errorMessage mudar
    }
  }, [errorMessage]);

  //verificar outra forma de enviar notificação ao administrador

  // useEffect(() => {
  //   if (successMessage) {
  //     const enviarEmailCadastro = async () => {
  //       const Token = validateToken();

  //       if (Token) {
  //         const URL = `${Globais.DOMINIOBACK}/usuario/email`;
  //         let formData = {
  //           userId: 1,
  //           tipoEmail: 0,
  //           subjectEmail: "Relação de hóspedes",
  //           bodyEmail: `Relação de hóspedes incluídas com sucesso! <br/><br/>

  //           Número reserva plataforma: ${idReservaOta.idReservaOta} <br/>

  //           `,
  //         };

  //         try {
  //           const response = await axios.post(URL, formData, {
  //             headers: { Authorization: Token.AuthStr },
  //           });
  //         } catch (error) {
  //           return false;
  //         }
  //       } else {
  //         document.location.href = "/";
  //       }
  //     };

  //     enviarEmailCadastro();
  //   }
  // }, [successMessage, idReservaOta.idReservaOta]); // Executa quando successMessage mudar

  const formatDateForMySQL = (): string => {
    const date = new Date();

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adiciona 1 porque getMonth() retorna de 0 a 11
    const day = String(date.getDate()).padStart(2, "0");

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  const formatarDataNascimento = (dateString: string): string => {
    const parts = dateString.split("/"); // Divide a string em partes

    if (parts.length !== 3) {
      throw new Error("Formato de data inválido. Use dd/mm/yyyy.");
    }

    const day = parts[0];
    const month = parts[1];
    const year = parts[2].length === 2 ? `20${parts[2]}` : parts[2]; // Para anos em dois dígitos, assume que são do século 21

    return `${year}-${month}-${day}`; // Retorna no formato yyyy-mm-dd
  };

  const convidadoChange = (
    changedValues: Partial<FormularioHospedes>,
    allValues: FormularioHospedes
  ) => {
    const errors: any = {};

    allValues.hospedes.forEach((hospede, index) => {
      if (!validarCPF(hospede.cpf)) {
        errors[`hospedes_${index}_cpf`] = "CPF inválido!";
      }

      if (!validarDataNascimento(hospede.dataNascimento)) {
        errors[`hospedes_${index}_dataNascimento`] =
          "Data de nascimento inválida!";
      }
    });

    setErrorFields(errors);

    setFormConvidado(allValues); // Atualiza os valores do formulário
  };

  const cadastrarConvidado = async () => {
    const reservaOta = await verificarReserva();
    if (reservaOta) {
      const reserva = await cadastrarReserva();
      if (reserva) {
        const buscarUser = await buscarUsuario();

        if (buscarUser) {
          // Aqui, idReservaRef.current deve ser definido corretamente

          setSuccessMessage(true);
          form.resetFields();
        }
      } else {
        throw Error(
          "Não foi possivel realizar o cadastro dos hospedes, por favor entre em contato!"
        );
      }
    } else {
      setErrorMessage(
        <>
          Relação de hóspedes já enviada. Clique
          <a href={`${Globais.DOMINIOFRONT}/contato`}> aqui</a> caso queria
          falar conosco.
        </>
      );
    }
  };

  const verificarReserva = async (): Promise<boolean> => {
    const URL = `${Globais.DOMINIOBACK}/reserva/ota/${idReservaOta.idReservaOta}`;
    try {
      const response = await axios.get(URL);

      if (Object.keys(response.data).length > 0) {
        throw new Error(
          "Reserva já cadastrada! Caso queria alterar a relação dos hóspedes entre em contato conosco"
        );
      } else {
        return true;
      }
    } catch (error) {
      console.error(
        error,
        "Erro ao buscar as reservas OTA, por favor tente novamente"
      );
      setErrorMessage("Erro , por favor tente novamente!");
      return false;
    }
  };

  const cadastrarReserva = async (): Promise<boolean> => {
    const URL = `${Globais.DOMINIOBACK}/reserva`;
    const values = {
      idReservaOta: idReservaOta.idReservaOta,
      dataReserva: formatDateForMySQL(),
    };

    console.log("values");
    console.log(values);

    try {
      const response = await axios.post(URL, values);

      // Atualização do ref com o id da reserva cadastrada
      idReservaRef.current = response.data.id;

      return true;
    } catch (error) {
      console.error(error, "Erro ao cadastrar, por favor tente novamente");
      setErrorMessage("Erro ao cadastrar reserva, por favor tente novamente!");
      return false;
    }
  };

  const buscarUsuario = async (): Promise<boolean> => {
    const URL = `${Globais.DOMINIOBACK}/usuario/buscarHospede`;
    let allSuccess = true; // Variável para rastrear o sucesso de todos os cadastros

    // Iterar sobre os campos do formConvidado
    for (const key of Object.keys(formConvidado)) {
      const value = formConvidado[key as keyof typeof formConvidado];

      // Se a chave for 'hospedes', iterar sobre o array
      if (key === "hospedes" && Array.isArray(value)) {
        for (const hospede of value) {
          try {
            const response = await axios.post(URL, { cpf: hospede.cpf });
            if (Object.keys(response.data).length > 0) {
              // Usuário já existe
              const sucesso = await cadastrarHospedes(
                response.data.id,
                // hospede.dataNascimento
              );
              if (!sucesso) {
                allSuccess = false; // Se falhar, marque como falha
              }
            } else {
              // Cadastrar novo usuário
              const sucesso = await cadastrarUsuario(
                hospede.nome,
                hospede.cpf,
                hospede.dataNascimento
              );
              if (!sucesso) {
                allSuccess = false; // Se falhar, marque como falha
              }
            }
          } catch (error) {
            console.error(error, "Não foi possível verificar usuário!");
            allSuccess = false; // Se ocorrer erro, marque como falha
          }
        }
      } else {
        setErrorMessage("Erro! Não foi possivel realizar o cadastro");
        return false; // Se não for hóspede, retorna false
      }
    }

    return allSuccess; // Retornar true se todos os cadastros foram bem-sucedidos
  };

  const cadastrarUsuario = async (
    nome: string,
    cpf: string,
    dataNascimento: string
  ): Promise<boolean> => {
    const URL = `${Globais.DOMINIOBACK}/usuario/hospede`;
    const dataFormatada = formatarDataNascimento(dataNascimento);




    const values = {
      nome: nome,
      cpf: cpf,
      dataNascimento: dataFormatada,
    };

    try {
      const response = await axios.post(URL, values, {});

      const sucess = await cadastrarHospedes(response.data.id);

      if (sucess) {
        return true;
      } else {
        setErrorMessage(
          "Erro ao cadastrar hospedes, por favor tente novamente!"
        );
        return false;
      }
    } catch (error) {
      setErrorMessage("Erro ao cadastrar usuário, por favor tente novamente!");
      return false;
    }
  };
  const cadastrarHospedes = async (
    idUsuario: number,
    // dataNascimento: string
  ): Promise<boolean> => {
    // const dataFormatada = formatarDataNascimento(dataNascimento);

    const URL = `${Globais.DOMINIOBACK}/hospedes`;
    const values = {
      idUsuario: idUsuario,
      idReserva: idReservaRef.current,
      // dataNascimento: dataFormatada,
    };

    try {
      const response = await axios.post(URL, values);

      return true;
    } catch (error) {
      console.error(error);
      setErrorMessage("Erro ao cadastrar hospedes, por favor tente novamente!");
      return false;
    }
  };

  // Verificadores de data nascimento e cpf
  // Função de validação do CPF
  const validarCPF = (cpf: string) => {
    cpf = cpf.replace(/[^\d]+/g, ""); // Remove caracteres não numéricos
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false; // Verifica se o CPF tem 11 dígitos e não é repetitivo
    let soma = 0;
    let resto;

    // Valida o primeiro dígito verificador
    for (let i = 1; i <= 9; i++)
      soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10))) return false;

    soma = 0;

    // Valida o segundo dígito verificador
    for (let i = 1; i <= 10; i++)
      soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;

    return true;
  };

  // Função para validar a data de nascimento
  const validarDataNascimento = (dataNascimento: string) => {
    const dataNasc = moment(dataNascimento, "DD/MM/YYYY");
    const dataAtual = moment(); // Pega a data atual
    const anoAtual = dataAtual.year();
    const anoLimiteMin = anoAtual - 110;

    // Verifica se a data é válida e não é uma data no futuro
    if (!dataNasc.isValid() || dataNasc.isAfter(dataAtual)) {
      return false;
    }

    const anoNascimento = dataNasc.year();

    // Verifica se o ano de nascimento está dentro do intervalo permitido
    return anoNascimento >= anoLimiteMin && anoNascimento <= anoAtual;
  };
  // Verifica se há erros
  const hasErrors = Object.keys(errorFields).length > 0;

  //-------------------- Componente Principal -----------------------------\\

  return !successMessage ? (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f0f4f7",
      }}
    >
      <div
        style={{
          justifyContent: "center",
          margin: "10px",
        }}
      >
        {errorMessage && (
          <div
            style={{
              textAlign: "center",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            <Alert message={errorMessage} type="error" showIcon />
          </div>
        )}
        <Form
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 18 }}
          form={form}
          name="dynamic_form_complex"
          onValuesChange={(changedValues, allValues) =>
            convidadoChange(changedValues, allValues)
          }
          onFinish={cadastrarConvidado}
          style={{ maxWidth: 600 }}
          autoComplete="off"
          initialValues={{
            hospedes: [{ nome: "", cpf: "", dataNascimento: "" }],
          }}
        >
          <Form.List name="hospedes">
            {(fields, { add, remove }) => (
              <div
                style={{
                  display: "flex",
                  rowGap: 16,
                  flexDirection: "column",
                }}
              >
                {fields.map((field, index) => (
                  <Card
                    size="small"
                    title={`Hóspede ${index + 1}`}
                    key={field.key}
                    extra={
                      index !== 0 && (
                        <CloseOutlined
                          onClick={() => {
                            remove(field.name);
                          }}
                        />
                      )
                    }
                  >
                    <Form.Item label="Nome" name={[field.name, "nome"]}>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="CPF"
                      name={[field.name, "cpf"]}
                      validateStatus={
                        errorFields[`hospedes_${index}_cpf`] ? "error" : ""
                      }
                      help={errorFields[`hospedes_${index}_cpf`] || ""}
                      rules={[{ required: true, message: "CPF é obrigatório" }]}
                    >
                      <MaskedInput mask="000.000.000-00" />
                    </Form.Item>
                    <Form.Item
                      label="Data de nascimento"
                      name={[field.name, "dataNascimento"]}
                      validateStatus={
                        errorFields[`hospedes_${index}_dataNascimento`]
                          ? "error"
                          : ""
                      }
                      help={
                        errorFields[`hospedes_${index}_dataNascimento`] || ""
                      }
                      rules={[
                        {
                          required: true,
                          message: "Data de nascimento é obrigatória",
                        },
                      ]}
                    >
                      <MaskedInput mask="00/00/0000" />
                    </Form.Item>
                  </Card>
                ))}

                <Button
                  type="dashed"
                  onClick={() => {
                    if (fields.length < 7) {
                      add();
                    }
                  }}
                  block
                  disabled={fields.length >= 7}
                >
                  + Adicionar Hóspede
                </Button>

                {fields.length >= 7 && (
                  <div style={{ color: "red", textAlign: "center" }}>
                    Limite de 7 hóspedes alcançado.
                  </div>
                )}
              </div>
            )}
          </Form.List>
          <Form.Item
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ButtonStyle disabled={hasErrors} type="submit">
              Enviar
            </ButtonStyle>
          </Form.Item>
        </Form>
      </div>
    </div>
  ) : (
    <div
      style={{
        width: "100vw",
        height: "50vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        backgroundColor: "#f0f4f7",
        padding: "20px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
      }}
    >
      <p
        style={{
          fontSize: "32px",
          fontWeight: "bold",
          alignContent: "center",
          color: "#003644", // cor sutilmente mais escura para contraste
          margin: "0", // remove margem para centralização mais limpa
        }}
      >
        Hóspedes incluídos com sucesso! <br/><br/>Agora está tudo certo com sua reserva.
      </p>
      <br/><br/>
      <p
        style={{
          fontSize: "22px",
          fontWeight: "normal",
          color: "#003644",
          marginTop: "10px", // espaço entre as frases
        }}
      >
        A Multicotas agradece pelas informações.<br/><br/>
        Qualquer dúvida clique <a
            href="/contato"
            target="_blank"
            id="zap"
            rel="noreferrer"
          >aqui </a>e entre em contato conosco. 
        
      </p>
    </div>
  );
}
